import { HttpErrorResponse } from '@angular/common/http';

import { VALIDATION_MESSAGES } from '@core/utils/validation-messages';

export function myProfileErrorMessage(
  error: HttpErrorResponse,
  message?: string
): string {
  const serverError = error?.error || {};

  switch (true) {
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'email_already_verified'
    ):
      return VALIDATION_MESSAGES.EmailAlreadyVerified;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'name_already_exists'
    ):
      return VALIDATION_MESSAGES.NameAlreadyExists;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'email_already_exists'
    ):
      return VALIDATION_MESSAGES.EmailAlreadyExists;
    case Object.prototype.hasOwnProperty.call(serverError, 'user_not_found'):
      return VALIDATION_MESSAGES.UserNotFound;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'cannot_change_current_account'
    ):
      return VALIDATION_MESSAGES.CannotChangeCurrentAccount;
    case Object.prototype.hasOwnProperty.call(serverError, 'account_not_found'):
      return VALIDATION_MESSAGES.AccountNotFound;
    case Object.prototype.hasOwnProperty.call(
      serverError,
      'invalid_sort_column'
    ):
      return VALIDATION_MESSAGES.InvalidSortColumn;

    default:
      return message ?? 'Unknown error';
  }
}
